<template>
  <div id="event-loading" v-if="isLoading">
    <!-- Placeholder image or loading indicator -->
    <img class="d-none d-md-block" style="opacity:0.6;"
      src="/wp-content/themes/understrap-child/fidelio-templates/images/fourCardsPlaceholder.svg" alt="">
    <img class="d-md-none" style="opacity:0.6;"
      src="/wp-content/themes/understrap-child/fidelio-templates/images/categoryPlacholderMobile.svg" alt="">
  </div>
  <div v-if="events && events.length" class="bg-white mb-4 px-5 py-1 rounded-corners-10 events">
    <div class="text-primary my-3">
      <h5 class="font-weight-bolder" style="font-size: x-large;">{{ $t('CategoryPage.liveEvents') }}</h5>
    </div>
    <div class="splide eventSplide newFeatureSlider" aria-label="Slider for courses">
      <div class="sands-article-vueslidercontainer splide__track">
        <div class="splide__list">
          <div class="splide__slide mb-5 mt-3 mt-lg-2" v-for="(event, i) in filteredCourses" :key="i">
            <div aria-hidden="false" class="h-100">
              <a :href="constructCourseURL(event)">
                <div class="card-container">
                    <img v-if="event.teaserImage && event.teaserImage.xx" itemprop="image" :src="event.teaserImage.xx"
                      loading="lazy" class="card-img rounded-top">
                  <div class="d-flex flex-column mt-2">
                    <a>
                      <p v-if="event.name" style="font-size: larger;" class="text-dark course-name-card">
                        {{ event.name }}
                      </p>
                    </a>
                    <div class="align-items-end d-flex h-75 w-100">
                      <div class="d-flex text-dark flex-wrap course-card-footer">
                        <div class="d-flex mr-3">
                          <div v-if="event.localizedStartDate" class="py-1">
                            {{ formatEventDates(event.localizedStartDate, event.localizedEndDate) }}
                          </div>
                          <cite v-if="event.experts" class="text-secondary">
                            <span>{{ event.experts.name }} \ {{ event.experts.forename }}</span>
                          </cite>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </a>  
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Splide from '@splidejs/splide';
import moment from 'moment';
import CONCORD_QUERIES from "../../services/concord_queries.js";
import helperFunction from "../../services/helperfunctions.js";
import { watch } from 'vue';
import useElementVisible from "../../services/elementVisibilityService.js";
import axios_queries from '../../services/axios_queries.js';

export default {
  name: "categoryConference",
  props: {
    settingsPerm: Object,
  },
  data() {
    return {
      isLoading: false,
      events: [],
      loadMorePossible: true,
      isDevMioActive: false,
      currentPage: 1,
      metaCount: 0,
      splide: null,
      test: false,
      firstTimeInViewport: true,
      initialDataLoaded: false,
    }
  },


  created() {
    this.isLoading = true;
    setTimeout(() => {
      this.box1Ref = document.getElementById("event-loading");

      if (this.box1Ref) {
          const isVisible = useElementVisible(this.box1Ref);
          if (isVisible && isVisible.value && isVisible.value == true) {
              this.firstTimeInViewport = false;
              this.loadInitialData();
          }

          watch(isVisible, (newValue) => {
              if (this.firstTimeInViewport && isVisible && newValue === true) {
                  this.firstTimeInViewport = false;
                  this.loadInitialData();
              }
              // Do something when isVisible changes
          });
      }
      this.emitter.on('highloadsProcessed', () => {
        this.firstTimeInViewport = false;
        this.loadInitialData();
      });
    }, 500);
  },

  methods: {
    loadInitialData() {
      if (!this.initialDataLoaded) {
        this.initialDataLoaded = true;
        let vueEventLoadingParams = {
            page: 1,
            pagesize: 25,
            querystring: this.settingsPerm.cat,
            transientKey: this.settingsPerm.cat + '-cat-depending-highlights-vue-events',
            query: "cat-depending-highlights-vue",
            url: this.settingsPerm.ajaxUrl+'/wp-content/uploads/catpages/'+this.settingsPerm.cat+'-cat-depending-highlights-vue-events.json'
        };
        axios_queries.loadPublicData(vueEventLoadingParams).then((concordData) => {
          if (concordData && concordData != null && concordData != undefined && concordData != '') {
              if(concordData.advancedSearch && concordData.advancedSearch.highlights && concordData.advancedSearch.highlights.courses && concordData.advancedSearch.highlights.courses.Courses && concordData.advancedSearch.highlights.courses.Courses.length) {
                let filteredCourses = concordData.advancedSearch.highlights.courses.Courses.filter(event => {
                  return event.genre === 'FSLE';
                })
                if (filteredCourses && filteredCourses.length >= 3) {
                  this.displayEvent(filteredCourses);
                }else{
                  this.isLoading = false;
                  this.emitter.emit('eventsProcessed', true);
                }
              }else{
                this.isLoading = false;
                this.emitter.emit('eventsProcessed', true);
              }
            }else{
              this.isLoading = false;
              this.emitter.emit('eventsProcessed', true);
            }
        })
      }
    },
    displayEvent(events){
      this.events = events;
      this.isLoading = false;
      this.mount_splide();
    },

    async loadMoreData() {
      // Make an API call to fetch more data
      this.currentPage++;
      let variablesForQuery = {
        page: this.currentPage,
        pagesize: 16,
        querystring: this.settingsPerm.cat,
      };
      let graphqlQuery = CONCORD_QUERIES.CAT_SPECIFIC_HIGHLIGHT;

      let concordData = await axios_queries.getMoreData(graphqlQuery,variablesForQuery);
        if (concordData.advancedSearch && concordData.advancedSearch.highlights && concordData.advancedSearch.highlights.courses && concordData.advancedSearch.highlights.courses.Courses && concordData.advancedSearch.highlights.courses.Courses.length) {
          let newevents = concordData.advancedSearch.highlights.courses.Courses;
          let filteredEvents = newevents.filter(event => event.genre === 'FSLE');
          // console.log('New events',newevents);
          if (filteredEvents && filteredEvents.length) {
            this.events = [...this.events, ...filteredEvents];
          }
          // console.log('events',this.events);
          this.mount_splide();
        }
    },

    addMovedEventListener() {
      this.splide.on('moved', (newIndex) => {
        const lastCardIndex = newIndex + this.splide.options.perPage;
        // console.log('lastcardindex', lastCardIndex);
        // console.log('lenght', this.events.length);

        if (lastCardIndex === this.events.length - 2 && this.events.length > this.metaCount) {
          this.loadMoreData();
        }
      });
    },

    constructCourseURL(concordObject) {
      return helperFunction.sandsConstructRealUrl(concordObject);
    },

    formatEventDates(startDate, endDate) {
      const startMoment = moment(startDate, 'DD-MM-YYYY HH:mm:ss');
      const endMoment = moment(endDate, 'DD-MM-YYYY  HH:mm:ss');

      if (startMoment.isValid() && endMoment.isValid()) {
        const formattedStartDate = startMoment.format('DD. MMMM YYYY | HH:mm');
        const formattedEndDate = endMoment.format('HH:mm');

        return `${formattedStartDate} - ${formattedEndDate}`;
      } else {
        return "Invalid Date"; // Handle invalid dates gracefully
      }
    },

    mount_splide: function () {
      let thiz = this;
      setTimeout(function () {
        if (!thiz.splide) {
          thiz.splide = new Splide('.eventSplide', {
            classes: {
              prev: 'splide__arrow--prev xx',
              next: 'splide__arrow--next xxx',
              arrow: 'splide__arrow xxxx',
            },
            perPage: 4,
            perMove: 1,
            rewindByDrag: true,
            gap: '1rem',
            breakpoints: {
              1600: {
                perPage: 4,
                padding: {
                  right: "0rem",
                  left: "0rem",
                },
              },
              1200: {
                perPage: 3,
                padding: {
                  right: "0rem",
                  left: "0rem",
                },
              },
              991: {
                perPage: 2,
                padding: {
                  right: '0rem',
                  left: '0rem',
                }
              },
              767: {
                perPage: 1,
                padding: {
                  right: '0rem',
                  left: '0rem',
                }
              },
            },
            rewind: false,
            pagination: false,
            padding: {
              right: '0rem',
              left: '0rem',
            }
          });
          thiz.splide.mount();
          thiz.addMovedEventListener(); // Add event listener
        } else {
          thiz.splide.refresh(); // Refresh the existing Splide instance
        }
      }, 100);
    },


  },

  
  

  computed: {
    filteredCourses() {
      if (this.events) {
        // Filter the events by genre "FSLE"
        return this.events.filter(event => event.genre === 'FSLE');

      }
      return [];
    },
  },
};
</script>

<style>
.logo-overlay {
  background-color: rgba(255, 255, 255, .85);
  position: absolute;
  bottom: 150px;
  left: 0;
  padding: 3px 0 3px 0;
}
</style>